import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAppSelector } from "../../app/hooks";
import { User } from "../user/user";
import { savePostLoginRedirect } from "./postLoginRedirect";

type ProtectedRouteResult =
  | { user: null; isSessionLoading: true; loginRedirect: null }
  | { user: null; isSessionLoading: false; loginRedirect: JSX.Element }
  | { user: User; isSessionLoading: false; loginRedirect: null };

export const useProtectedRoute = (): ProtectedRouteResult => {
  const user = useAppSelector((state) => state.user.user);
  const status = useAppSelector((state) => state.user.status);
  const location = useLocation();
  const isSessionLoading = !user && (status === "" || status === "pending");

  useEffect(() => {
    if (isSessionLoading || user || status === "signedOut") return;
    savePostLoginRedirect(
      `${location.pathname}${location.search}${location.hash}`,
    );
  }, [isSessionLoading, user, status, location]);

  if (isSessionLoading) {
    return { user: null, isSessionLoading: true, loginRedirect: null };
  }

  if (!user) {
    return {
      user: null,
      isSessionLoading: false,
      loginRedirect: <Navigate to="/login" replace />,
    };
  }

  return { user, isSessionLoading: false, loginRedirect: null };
};
